import { Row, Col } from 'antd'
import CIMSFormItem from '../../../../CIMSFormItem'
import CIMSSelect from '../../../../CIMSSelect'
import AffectedValues from '../AffectedValues'
import { useState, useEffect, useCallback } from 'react'
import { MultipleStatusReversalProps, WorkflowStatus } from './types'
import { CommonWorkflowRollbackModalProps } from '../../types'
import Message from '../Message'

const MultipleStatusReversal: React.FC<
  MultipleStatusReversalProps &
    Pick<CommonWorkflowRollbackModalProps<any>, 'visible' | 'recordName'>
> = ({
  visible,
  recordName,
  statuses,
  affectedItems,
  formItems,
  parentPositions,
}) => {
  /**
   * allows for dynamic rollback items in multiple statuses
   */
  const [status, setStatus] = useState<WorkflowStatus | undefined>(undefined)
  const find = useCallback(
    (value?: string) => statuses.find(({ statusName }) => statusName === value),
    [statuses]
  )
  useEffect(() => {
    setStatus(find(status?.statusName))
  }, [find, status?.statusName, statuses])
  useEffect(() => setStatus(undefined), [visible])

  const affect = parentPositions?.affectedItems ?? 'after'
  const form = parentPositions?.formItems ?? 'after'
  return (
    <>
      <CIMSFormItem name="status">
        <CIMSSelect
          simple
          onChange={(value) => setStatus(find(value?.toString()))}
          placeholder={'Select a new status'}
          options={statuses.map(({ statusName: label, disabled }) => ({
            label,
            value: label,
            disabled,
          }))}
          style={{ width: 200 }}
        />
      </CIMSFormItem>
      {status && (
        <>
          <Message recordName={recordName} status={status.statusName} />
          <Row gutter={16}>
            <Col sm={12}>
              {affect === 'before' && (
                <AffectedValues
                  items={
                    typeof affectedItems === 'function'
                      ? affectedItems(status.statusName)
                      : affectedItems
                  }
                />
              )}
              <AffectedValues items={status.affectedItems} />
              {affect === 'after' && (
                <AffectedValues
                  items={
                    typeof affectedItems === 'function'
                      ? affectedItems(status.statusName)
                      : affectedItems
                  }
                />
              )}
            </Col>
            <Col sm={12}>
              {form === 'before' &&
                (typeof formItems === 'function'
                  ? formItems(status.statusName)
                  : formItems)}
              {status.formItems}
              {form === 'after' &&
                (typeof formItems === 'function'
                  ? formItems(status.statusName)
                  : formItems)}
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

export default MultipleStatusReversal
